import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            {/* Custom TS Logo Mark */}
            <div className="relative w-18 h-18 flex items-center justify-center">
              <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-18 h-18" style={{width: '72px', height: '72px'}}>
                {/* Swoosh orbit ellipse */}
                <ellipse
                  cx="24" cy="24" rx="21" ry="9"
                  stroke={isScrolled ? '#2563eb' : '#93c5fd'}
                  strokeWidth="2.2"
                  fill="none"
                  transform="rotate(-20 24 24)"
                  strokeLinecap="round"
                  strokeDasharray="90 20"
                />
                {/* TS text */}
                <text
                  x="24" y="30"
                  textAnchor="middle"
                  fontFamily="'Georgia', serif"
                  fontWeight="700"
                  fontSize="18"
                  fill={isScrolled ? '#2563eb' : '#ffffff'}
                  letterSpacing="-1"
                >TS</text>
              </svg>
            </div>
            <span className={`text-xl font-bold whitespace-nowrap tracking-wide leading-none self-center ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              Top Shelf <span className={isScrolled ? 'text-blue-600' : 'text-blue-300'}>Solutions</span>
            </span>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Our Process
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Testimonials
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-blue-600 py-2 whitespace-nowrap"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-blue-600 py-2 whitespace-nowrap"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-blue-600 py-2 whitespace-nowrap"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-blue-600 py-2 whitespace-nowrap"
            >
              Our Process
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-blue-600 py-2 whitespace-nowrap"
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-blue-600 py-2 whitespace-nowrap"
            >
              Testimonials
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;